import "./experience.css";
import { ReactComponent as WorkIcon } from "./work.svg";
import { ReactComponent as SchoolIcon } from "./school.svg";
import CustomButton from '../../components/Custom/CustomButton';
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import timelineElements from "./timelineElements";

function Experience() {
	let workIconStyles = { background: "#06D6A0" };
	let schoolIconStyles = { background: "#f9c74f" };

	return (
		<div className="expCont flex flex-col items-center mt-40 mb-10">
			<div className='text-2xl mb-14 font-bai'>
				<span className='text-neon font-extrabold' data-aos="zoom-in-left" data-aos-offset="120">&lt;</span>
				<span data-aos="zoom-in-up" data-aos-offset="120"> Experience </span>
				<span className='text-neon font-extrabold' data-aos="zoom-in-right" data-aos-offset="120">/ &gt;</span>
			</div>
			<VerticalTimeline className="font-bai">
				{timelineElements.map((element, index) => {
					let isWorkIcon = element.icon === "work";
					let showButton =
						element.buttonText !== undefined &&
						element.buttonText !== null &&
						element.buttonText !== "";

					return (
						<VerticalTimelineElement
							key={index}
							className="tabs"
							date={element.date}
							dateClassName="date"
							iconStyle={isWorkIcon ? workIconStyles : schoolIconStyles}
							icon={isWorkIcon ? <WorkIcon /> : <SchoolIcon />}
							style={{
								"--border-color": `${isWorkIcon ? "#00fffc" : "#f9c74f"}`,
							}}
						>
							<h3 className="font-semibold mb-1 lg:text-lg text-md">
								{element.title}
							</h3>
							<h5 className="vertical-timeline-element-subtitle text-gray-400 lg:text-sm text-xs">
								{element.location}
							</h5>
							<div className="leading-6 my-6 text-gray-300 lg:text-md text-sm">{element.description}</div>
							{showButton && (
								<CustomButton theme={`${isWorkIcon ? "#00fffc" : "#f9c74f"}`} text={element.buttonText} onHandle={() => window.open(element.buttonHref, '_blank', 'noreferrer')} />
							)}
						</VerticalTimelineElement>
					);
				})}
			</VerticalTimeline>
		</div>
	);
}

export default Experience;